import React, { useState } from 'react'
import styled from 'styled-components'
import { TimeReleaseClaim, useEthers } from '../../../hooks'
import { CurrencyValue } from '../../../model'
import { ConfirmClaim } from './ConfirmClaim'
import { useConnectModal } from '../../../providers'
import { ActionButton } from '../ActionButton'

interface Props {
  option1Claimable?: CurrencyValue
  option2Claimable?: CurrencyValue
  timeReleaseAddress: string
  timeReleaseClaim?: TimeReleaseClaim
}

export function ClaimButton({ option1Claimable, option2Claimable, timeReleaseAddress, timeReleaseClaim }: Props) {
  const { account } = useEthers()
  const { setConnectModalOpen } = useConnectModal()
  const [open, setOpen] = useState(false)
  const disabled =
    !account ||
    !option1Claimable ||
    !option2Claimable ||
    (option1Claimable.value.isZero() && option2Claimable.value.isZero())
  !option1Claimable || !option2Claimable || (option1Claimable.value.isZero() && option2Claimable.value.isZero())

  return (
    <Container>
      <ActionButton
        disabled={disabled}
        onClick={() => {
          if (!account) {
            setConnectModalOpen()
            return
          }

          setOpen(true)
        }}
      >
        Claim
      </ActionButton>
      {open && option1Claimable && option2Claimable && (
        <ConfirmClaim
          option1Claimable={option1Claimable}
          option2Claimable={option2Claimable}
          timeReleaseAddress={timeReleaseAddress}
          timeReleaseClaim={timeReleaseClaim}
          onClose={() => setOpen(false)}
          onSubmit={() => setOpen(false)}
        />
      )}
    </Container>
  )
}

const Container = styled.div``
